import {HandCoins, PocketKnife} from "lucide-react";
import {Tooltip} from "antd";
import React from "react";
import {CreditCardTwoTone} from "@ant-design/icons";
import {colors} from "../theme/antdTheme";

export function orderProcessingTimeColor(time) {
    if (time < 15) return 'green';
    if (time < 30) return 'orange';
    return 'red';
}


const PAYMENT_CONFIG = {
    card: {
        icon: CreditCardTwoTone,
        color: colors.primary,
        labelKey: 'pages.orders.hoverText.text2',
        size: 20,
    },
    cash: {
        icon: HandCoins,
        color: '#4CAF50',
        labelKey: 'pages.orders.hoverText.text1',
        size: 18,
    },
    uncork: {
        icon: PocketKnife,
        color: '#ff4d4f',
        labelKey: 'pages.orders.hoverText.text3',
        size: 18,
    },
};

export function PaymentTypeIcon({type, t}) {
    const config = PAYMENT_CONFIG[type];

    if (!config) return null;

    const {icon: Icon, color, labelKey, size} = config;

    return (
        <Tooltip title={t(labelKey)}>
            <Icon size={size} style={{color}}/>
        </Tooltip>
    );
}

export const DefinePaymentType = (type, paymentType, orderPrice) =>
    orderPrice === 0 && type === 'prepaid' ? 'uncork' : paymentType;

// export function DefinePaymentType(type, paymentType, orderPrice) {
//     // console.log("type:", type, "price:", orderPrice)
//
//     if (orderPrice === 0 && type === 'prepaid')
//         return 'uncork'
//
//     // console.log('after if statement')
//     return paymentType
// }